import {
  Autocomplete,
  Pagination as MuiPagination,
  TablePaginationProps,
  TextField,
  Typography,
} from "@mui/material";

import {
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-pro";

import __ from "src/utils/Translations";

const Pagination = ({
  page,
  onPageChange,
  className,
}: Pick<TablePaginationProps, "page" | "onPageChange" | "className">) => {
  const apiRef = useGridApiContext();
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <>
      <Typography sx={{ marginLeft: "1.5rem" }}>{__("Strona")}</Typography>
      <Autocomplete
        value={String(page + 1)}
        onChange={(event, value) =>
          onPageChange(
            event as unknown as React.MouseEvent<HTMLButtonElement, MouseEvent>,
            Number(value) - 1
          )
        }
        options={[...Array(pageCount)].map((_, i) => String(i + 1))}
        disableClearable
        renderInput={(params) => (
          <TextField
            variant="standard"
            {...params}
            sx={{
              marginLeft: "0.5rem",
              marginRight: "1rem",
              paddingLeft: "0.5rem",
            }}
          />
        )}
      />
      <MuiPagination
        color="primary"
        className={className}
        count={pageCount}
        page={page + 1}
        shape="rounded"
        showFirstButton
        showLastButton
        size="small"
        variant="outlined"
        onChange={(event, newPage) => {
          onPageChange(
            event as React.MouseEvent<HTMLButtonElement, MouseEvent>,
            newPage - 1
          );
        }}
      />
    </>
  );
};

export default Pagination;
